import { type HTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { CardFrame } from '@/components/base/CardFrame'
import { BackgroundImage } from '@/components/base/BackgroundImage'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  backgroundImageUrl?: string
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, backgroundImageUrl, accentColor, className, ...props }, ref) => {
    return (
      <CardFrame
        accentColor={accentColor}
        className={twMerge('relative overflow-hidden p-0', className)}
        ref={ref}
        {...props}
      >
        {backgroundImageUrl ? <BackgroundImage imageSrc={backgroundImageUrl} /> : null}

        <div className="relative z-20 p-2">{children}</div>
      </CardFrame>
    )
  }
)

Card.displayName = 'Card'
